import { getVar } from '@Sage/ssm-utils';

export const LOAD_TIMEOUT = 10000;
export const RETRY_DELAY = 1000;
export const MAX_RETRIES = 3;

export const getTopolOptions = ({ containerId, onSave, onInit, onError, theme, variables }) => {
    const themeColors = theme?.colors || {};
    const mergeTags = variables || [];
    return {
        id: containerId ? `#${containerId}` : '#topol-app',
        authorize: {
            apiKey: 'YN06EwYAdm0TrwOMNsZ5UnsM4vq1T1mnAOuZMSLpcsUxhOoLzUElMA0Kw6ht',
            userId: 'UserID',
        },
        topBarOptions: ['undoRedo', 'previewSize'],
        callbacks: {
            onSave,
            onInit,
            onError: (error) => {
                console.error('Topol Editor Error:', error);
                onError?.(error);
            },
        },

        templates: [],
        savedBlocks: [],
        title: '',
        syncedSectionsEnabled: true,
        mobileFirstEnabled: true,
        disableAlerts: true,
        mergeTags,
        theme: {
            preset: 'light',
            colors: {
                // Neutral grays - used for backgrounds, borders and editor text
                900: '#fff', // Main editor background, primary work areas, general canvas
                800: getVar(themeColors.grey?.[50]), // Tab bar background, secondary content areas, sidebar sections
                700: getVar(themeColors.utility?.bg), // Dropdown menus, popovers, tooltips backgrounds
                600: getVar(themeColors.grey?.[50]), // General buttons background, toolbar bars, editor controls
                500: getVar(themeColors.grey?.[200]), // Panel borders, horizontal/vertical dividers, section separator lines
                400: getVar(themeColors.grey?.[300]), // Input field borders, inactive form fields, editable field lines
                300: getVar(themeColors.grey?.[500]), // Inactive icons, field placeholders, disabled element text
                200: getVar(themeColors.grey?.[600]), // Secondary button text, form labels, auxiliary descriptions
                100: getVar(themeColors.grey?.[600]), // Button icons, tool icons, navigation icons
                50: getVar(themeColors.grey?.[800]), // Main content text, section titles, block names
                10: getVar(themeColors.grey?.[900]), // High intensity text, source code, technical text, preformatted text
                white: '#ffffff', // Modal overlay backgrounds, elevated cards, floating dropdowns, modals

                // Primary colors - used for main brand elements and primary interactions
                primary: getVar(themeColors.actionMinor?.[500]), // Primary buttons, interactive links, main selection indicators, main accents
                'primary-light': getVar(themeColors.actionMinor?.[400]), // Primary button hover states, soft active states, secondary brand accents
                'primary-light-2': getVar(themeColors.actionMinor?.[200]), // Light selection backgrounds, active element highlights, primary state badges

                // Secondary colors - alternative accents and positive/confirmation actions
                secondary: getVar(themeColors.actionMajor?.[500]), // Secondary buttons, alternative actions, confirmation buttons, positive actions
                'secondary-light': getVar(themeColors.actionMajor?.[350]), // Secondary button hover states, progress indicators, completed loading states
                'secondary-light-2': getVar(themeColors.actionMajor?.[150]), // Success notification backgrounds, confirmation badges, completed states

                // Error colors - error states, failed validation and critical alerts
                error: getVar(themeColors.semantic?.negative500), // Validation error messages, invalid field borders, critical error icons
                'error-light': getVar(themeColors.semantic?.negative450), // Error state hover, important alerts, error notifications

                // Success colors - confirmations, correct validation and positive states
                success: getVar(themeColors.semantic?.positive500), // Successful validation states, confirmation icons, completion indicators
                'success-light': getVar(themeColors.semantic?.positive400), // Success message backgrounds, positive badges, confirmation notifications

                // Active states - indicators for currently active tools/selections
                active: getVar(themeColors.actionMinor?.[500]), // Currently selected elements, active edit mode, tool currently in use
                'active-2': getVar(themeColors.semantic?.positive500), // Toggle ON states, activated switches, positive alternation, enabled controls
                'active-3': getVar(themeColors.semantic?.focus500), // Warning active states, active mode cautions requiring immediate attention
            },
        },
        textOverride: {
            'blocks.premade_content': 'Components',
        },
        customBlocks: [
            {
                key: 'custom-block-key',
                name: 'Bocked component',
                dialog: true,
                icon: 'box',
                content: '<p>Locked component that cannot be edited</p>',
                dialogButtonText: 'Open Custom Dialog',
                disabled: false,
            },
        ],
    };
};
